import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faPaperPlane } from '@fortawesome/free-regular-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import Img from 'gatsby-image'
//import Link from 'gatsby-link'

import Scroll from '../components/Scroll'
import Nav from '../components/Nav'

const meImg = require('../img/me.jpg')
const lucyImg = require('../img/lucy.jpg')
const lesiaImg = require('../img/lesik.jpg')
const iPadImg = require('../img/ipad.png')

const IndexPage = ({ data }) => (
  <div>
    <Nav />

    <header className="masthead" id="page-top">
      <div className="container d-flex h-100 align-items-center">
        <div className="mx-auto text-center">
          <h1 className="mx-auto my-0 text-uppercase">Basebit</h1>
          <h2 className="text-white-50 mx-auto mt-2 mb-5">A white label, crypto currency exchange as a service for businesses</h2>
          <Scroll type="id" element="signup" offset={5}>
            <a href="#signup" className="btn btn-primary js-scroll-trigger">Subscribe for early access</a>
          </Scroll>
        </div>
      </div>
    </header>

    <section id="about" className="about-section text-center">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <h2 className="text-white mb-4">Secure, performant, flexible and ready to go</h2>
            <p className="text-white-50">Don't spend a fortune. Don't waste precious time. Basebit allows you to start operating a secure, scalable crypto currency exchange in a matter of hours.</p>
          </div>
        </div>
        <Img sizes={data.iPadImage.sizes} className="img-fluid" alt="iPad screen shot" />
      </div>
    </section>


    <section id="team" className="projects-section bg-light">
      <div className="container">

        <div className="row align-items-center no-gutters mb-4 mb-lg-5">
          <div className="col-xl-8 col-lg-7">
            <Img className="img-fluid mb-3 mb-lg-0" sizes={data.meImage.sizes} alt="" />
          </div>
          <div className="col-xl-4 col-lg-5">
            <div className="featured-text text-center text-lg-left">
              <h4>Founder: Andrew Katasonov</h4>
              <p className="text-black-50 mb-0">With more than 20 years of experience in IT, a multitude of projects delivered for medium to large size companies and inside out experience in crypto, Andrew makes ideas happen.</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center no-gutters mb-5 mb-lg-0">
          <div className="col-lg-6">
            <Img className="img-fluid" sizes={data.lucyImage.sizes} alt="" />
          </div>
          <div className="col-lg-6">
            <div className="bg-black text-center h-100 project">
              <div className="d-flex h-100">
                <div className="project-text w-100 my-auto text-center text-lg-left">
                  <h4 className="text-white">Lucy</h4>
                  <p className="mb-0 text-white-50">Lucy is a digital marketer and growth hacker.</p>
                  <hr className="d-none d-lg-block mb-0 ml-0" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row justify-content-center no-gutters">
          <div className="col-lg-6">
            <Img className="img-fluid" sizes={data.lesikImage.sizes} alt="" />
          </div>
          <div className="col-lg-6 order-lg-first">
            <div className="bg-black text-center h-100 project">
              <div className="d-flex h-100">
                <div className="project-text w-100 my-auto text-center text-lg-right">
                  <h4 className="text-white">Olesia</h4>
                  <p className="mb-0 text-white-50">Olesia is a senior developer fluent in muptiple technologies.</p>
                  <hr className="d-none d-lg-block mb-0 mr-0" />
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>

    <section id="signup" className="signup-section">
      <div className="container">
        <div className="row">
          <div className="col-md-10 col-lg-8 mx-auto text-center">

            <i className="far fa-paper-plane fa-2x mb-2 text-white"><FontAwesomeIcon icon={faPaperPlane} /></i>
            <h2 className="text-white mb-5">Subscribe for early access!</h2>

            <form className="form-inline d-flex" method="post" action="https://labs.katasonov.com/basebit-subscribe.php" onSubmit={() => {if (twq) twq('track','Subscribe');}}>
              <input type="email" className="form-control flex-fill mr-0 mr-sm-2 mb-3 mb-sm-0" id="inputEmail" name="email" placeholder="Enter email address..." required />
              <button type="submit" className="btn btn-primary mx-auto">Subscribe</button>
            </form>

          </div>
        </div>
      </div>
    </section>

    <section className="contact-section bg-black">
      <div className="container">

        <div className="row">

          { /*
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <i className="fas fa-map-marked-alt text-primary mb-2"></i>
                <h4 className="text-uppercase m-0">Address</h4>
                <hr className="my-4" />
                <div className="small text-black-50">4923 Market Street, Orlando FL</div>
              </div>
            </div>
          </div>
          */}

          <div className="col-md-12 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <i className="fas fa-envelope text-primary mb-2"><FontAwesomeIcon icon={faEnvelope} /></i>
                <h4 className="text-uppercase m-0">Email</h4>
                <hr className="my-4" />
                <div className="small text-black-50">
                  <a href="mailto:hello@basebit.io">hello@basebit.io</a>
                </div>
              </div>
            </div>
          </div>

          { /*
          <div className="col-md-4 mb-3 mb-md-0">
            <div className="card py-4 h-100">
              <div className="card-body text-center">
                <i className="fas fa-mobile-alt text-primary mb-2"></i>
                <h4 className="text-uppercase m-0">Phone</h4>
                <hr className="my-4" />
                <div className="small text-black-50">+1 (555) 902-8832</div>
              </div>
            </div>
          </div>
          */ }
        </div>

        <div className="social d-flex justify-content-center">
          <a href="https://twitter.com/basebit_io" className="mx-2">
            <FontAwesomeIcon icon={faTwitter} />
          </a>
          { /*
          <a href="#" className="mx-2">
            <FontAwesomeIcon icon={faFacebookF} />
          </a>
          <a href="#" className="mx-2">
            <FontAwesomeIcon icon={faGithub} />
          </a>
          */ }
        </div>

      </div>
    </section>

    <footer className="bg-black small text-center text-white-50">
      <div className="container">
        Copyright &copy; Basebit.io 2018
      </div>
    </footer>
  </div>
)

export default IndexPage

export const pageQuery = graphql`
  query imageQuery {
    meImage: imageSharp(id: { regex: "/me/" }) {
      sizes(maxWidth: 1024 ) {
        ...GatsbyImageSharpSizes
      }
    },
    lucyImage: imageSharp(id: { regex: "/lucy/" }) {
      sizes(maxWidth: 1024 ) {
        ...GatsbyImageSharpSizes
      }
    },
    lesikImage: imageSharp(id: { regex: "/lesik/" }) {
      sizes(maxWidth: 1024 ) {
        ...GatsbyImageSharpSizes
      }
    },
    iPadImage: imageSharp(id: { regex: "/ipad/" }) {
      sizes(maxWidth: 1240 ) {
        ...GatsbyImageSharpSizes
      }
    },
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js